module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/14AsYVQ/tc-custom/9780740786150.jpg?1707452598761",
      "alt": "This image is the cover for the book Scourge of Vinyl Car Seats, Close to Home"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Scourge of Vinyl Car Seats, Close to Home\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("No one walks away from a "), _c('i', [_vm._v("Close to Home")]), _vm._v(" cartoon unscathed. John McPherson's lumpy characters and bizarre situations are tailor-made for gut-splitting laughs. And then there are the cartoons that leave readers shaking their heads, sputtering, \"Oh my gosh\" as a guilty smile passes across their faces. "), _c('i', [_vm._v("The Scourge of Vinyl Car Seats")]), _vm._v(" delivers what fans expect from McPherson: jokes about everything from parenting to dating to car repairs. McPherson takes his readers on a journey that's very Close to Home.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John McPherson\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Andrews McMeel Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0